/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CalendarIcon64Regular = forwardRef('CalendarIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21.5 6A1.5 1.5 0 0 1 23 7.5v8a1.5 1.5 0 0 1-3 0v-8A1.5 1.5 0 0 1 21.5 6Z" }),
        React.createElement("path", { d: "M26 10h12v3H26v-3Z" }),
        React.createElement("path", { d: "M47.5 13H47v-3h.5C53.299 10 58 14.701 58 20.5v25C58 51.299 53.299 56 47.5 56h-31C10.701 56 6 51.299 6 45.5v-25C6 14.701 10.701 10 16.5 10h.5v3h-.5A7.5 7.5 0 0 0 9 20.5v25a7.5 7.5 0 0 0 7.5 7.5h31a7.5 7.5 0 0 0 7.5-7.5v-25a7.5 7.5 0 0 0-7.5-7.5Z" }),
        React.createElement("path", { d: "M16 23a1.5 1.5 0 0 0 0 3h32a1.5 1.5 0 0 0 0-3H16Z" }),
        React.createElement("path", { d: "M44 7.5a1.5 1.5 0 0 0-3 0v8a1.5 1.5 0 0 0 3 0v-8Z" }),
        React.createElement("path", { d: "M20.5 35a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M18.5 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M29.5 35a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M27.5 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M38.5 35a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M45.5 37a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M38.5 44a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M45.5 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
